/* =========================================================================
   8HP.shop — NFS Underground theme JS
   Cart interactions, mobile nav, search toggle, product gallery, variants
   ========================================================================= */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = window.Shopify && window.Shopify.money_format;
    const value = (cents / 100).toFixed(2);
    if (fmt) {
      return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
    }
    return '$' + value;
  };

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCartCount() {
    try {
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
    } catch (e) {
      /* noop */
    }
  }

  /* ---------------------- Mobile nav + search toggles ------------------- */
  function initToggles() {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', () => {
        mobileNav.classList.toggle('is-open');
        const search = document.querySelector('[data-header-search]');
        if (search) search.classList.remove('is-open');
      });
    }

    const searchToggle = document.querySelector('[data-search-toggle]');
    const headerSearch = document.querySelector('[data-header-search]');
    if (searchToggle && headerSearch) {
      searchToggle.addEventListener('click', () => {
        headerSearch.classList.toggle('is-open');
        if (headerSearch.classList.contains('is-open')) {
          const input = headerSearch.querySelector('input[type="search"]');
          if (input) input.focus();
        }
        if (mobileNav) mobileNav.classList.remove('is-open');
      });
    }
  }

  /* ---------------------- Add to cart ---------------------------------- */
  function initAddToCart() {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[data-add-to-cart]');
        const original = btn ? btn.textContent : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding…';
        }
        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Could not add to cart');
          }
          await refreshCartCount();
          if (btn) {
            btn.textContent = 'Added ✓';
            setTimeout(() => {
              btn.textContent = original;
              btn.disabled = false;
            }, 1500);
          }
          window.location.href = '/cart';
        } catch (err) {
          if (btn) {
            btn.textContent = err.message || 'Error';
            setTimeout(() => {
              btn.textContent = original;
              btn.disabled = false;
            }, 2000);
          }
        }
      });
    });
  }

  /* ---------------------- Quantity steppers ---------------------------- */
  function initQtySteppers() {
    document.querySelectorAll('[data-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      const dec = wrap.querySelector('[data-qty-dec]');
      const inc = wrap.querySelector('[data-qty-inc]');
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const max = parseInt(input.getAttribute('max') || '9999', 10);
      const clamp = (v) => Math.max(min, Math.min(max, v));
      if (dec) dec.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value || '1', 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (inc) inc.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value || '1', 10) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------------------- Cart line updates ---------------------------- */
  async function changeCartLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    return res.json();
  }

  function renderCart(cart) {
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }
    document.querySelectorAll('[data-cart-line]').forEach((el) => {
      const line = parseInt(el.getAttribute('data-cart-line'), 10);
      const item = cart.items[line - 1];
      if (!item) {
        el.remove();
        return;
      }
      const priceEl = el.querySelector('[data-line-price]');
      if (priceEl) priceEl.textContent = money(item.final_line_price);
      const qtyInput = el.querySelector('input[data-quantity-input]');
      if (qtyInput) qtyInput.value = item.quantity;
    });
    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    updateCartCount(cart.item_count);
  }

  function initCartPage() {
    const cartRoot = document.querySelector('[data-cart-root]');
    if (!cartRoot) return;

    cartRoot.querySelectorAll('[data-cart-line]').forEach((el) => {
      const line = parseInt(el.getAttribute('data-cart-line'), 10);
      const input = el.querySelector('input[data-quantity-input]');
      const remove = el.querySelector('[data-line-remove]');

      if (input) {
        input.addEventListener('change', async () => {
          const qty = Math.max(0, parseInt(input.value || '0', 10));
          const cart = await changeCartLine(line, qty);
          renderCart(cart);
        });
      }
      if (remove) {
        remove.addEventListener('click', async (e) => {
          e.preventDefault();
          const cart = await changeCartLine(line, 0);
          renderCart(cart);
        });
      }
    });
  }

  /* ---------------------- Product gallery ------------------------------ */
  function initGallery() {
    const gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    const mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-full');
        const alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.alt = alt;
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------------------- Variant selection ---------------------------- */
  function initVariants() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    const dataEl = document.querySelector('[data-variants-json]');
    if (!dataEl) return;
    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const addBtn = form.querySelector('[data-add-to-cart]');

    function currentOptions() {
      const opts = [];
      form.querySelectorAll('[data-option-index]').forEach((group) => {
        const idx = parseInt(group.getAttribute('data-option-index'), 10);
        const checked = group.querySelector('input:checked, select');
        let value = null;
        if (checked) {
          value = checked.tagName === 'SELECT' ? checked.value : checked.value;
        }
        opts[idx] = value;
      });
      return opts;
    }

    function findVariant(opts) {
      if (!opts.length && variants.length === 1) return variants[0];
      return variants.find((v) => {
        return (v.options || []).every((o, i) => o === opts[i]);
      });
    }

    function update() {
      const opts = currentOptions();
      const variant = findVariant(opts);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="price__sale">' + money(variant.price) + '</span> <del>' + money(variant.compare_at_price) + '</del>';
        } else {
          priceEl.textContent = money(variant.price);
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add-label') || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        }
      }
    }

    form.querySelectorAll('[data-option-index] input, [data-option-index] select').forEach((el) => {
      el.addEventListener('change', update);
    });
    update();
  }

  /* ---------------------- Init ----------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    initToggles();
    initAddToCart();
    initQtySteppers();
    initCartPage();
    initGallery();
    initVariants();
    refreshCartCount();
  });
})();
